import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b997814"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "dialog-header" }
const _hoisted_2 = {
  slot: "dialog-subheader",
  class: "onboarding-modal_subtitle"
}
const _hoisted_3 = {
  key: "expanded",
  class: "onboarding-modal_body_logo",
  src: "https://dam.malt.com/navbar/malt-logo-red.svg?vh=9690b2",
  width: "110",
  height: "35",
  alt: "Malt logo"
}
const _hoisted_4 = {
  key: 1,
  class: "onboarding-modal_body_splash flex"
}
const _hoisted_5 = { class: "onboarding-modal_body_splash_title" }
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = { class: "onboarding-modal_body_splash_subtitle" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://dam.malt.com/navbar/onboarding/new-client/FR/mobile/welcome-mobile.svg" }, null, -1))
const _hoisted_9 = {
  key: 2,
  class: "onboarding-modal_body_content flex"
}
const _hoisted_10 = {
  key: 0,
  class: "onboarding-modal_body_content_mobile-card"
}
const _hoisted_11 = {
  key: 1,
  class: "onboarding-modal_body_content_cards grid"
}
const _hoisted_12 = { class: "onboarding-modal_body_content_illustration" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  slot: "dialog-confirm",
  class: "onboarding-modal_body_footer flex"
}
const _hoisted_15 = {
  key: 0,
  class: "onboarding-modal_body_footer_indicators flex"
}

import {useOnboardingNewUser} from '@/logged/features/onboarding-new-user';
    import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import OnboardingNewUserCard from './OnboardingNewUserCard.vue';
    import {useTranslation} from '@malt/vue3-use';
    import {usePrefetchImages} from '@/logged/common/composables';
    import {useUser} from '@/logged/features/user';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NewUserOnboardingModal',
  setup(__props) {

    const t = useTranslation();
    const userStore = useUser();
    const onBoardingNewUserStore = useOnboardingNewUser();
    const {
        onboardingSteps,
        selectedOnboardingCard,
        selectedOnboardingCardIndex,
        selectedIllustation,
        isAtLastStep,
        isMobileSplashScreenDisplayed,
        filteredIllustrationsByLanguage,
    } = storeToRefs(onBoardingNewUserStore);

    const {matchMedia} = useMediaQuery();
    usePrefetchImages(filteredIllustrationsByLanguage);

    const isMobile = computed(() => matchMedia.value.max.Xs);

    const getCtaMessage = computed(() => {
        if (isAtLastStep.value) {
            return t.msg('navbar.onboarding.dialog.main.cta.close.title');
        } else {
            return t.msg('navbar.onboarding.dialog.main.cta.next.title');
        }
    });

    function handleCancelDialog() {
        userStore.acknowledgeOnboarding();
    }

    function handleSpashScrenConfirm() {
        isMobileSplashScreenDisplayed.value = false;
        userStore.acknowledgeOnboarding(false);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_button = _resolveComponent("joy-button")!
  const _component_joy_indicator = _resolveComponent("joy-indicator")!
  const _component_joy_indicators = _resolveComponent("joy-indicators")!
  const _component_joy_dialog = _resolveComponent("joy-dialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_joy_dialog, {
      id: "new-user-onboarding-modal",
      "data-testid": "new-user-onboarding-modal",
      open: "",
      class: "onboarding-modal",
      size: "large",
      onJoyCancelDialog: handleCancelDialog
    }, {
      default: _withCtx(() => [
        (!isMobile.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$msg('navbar.onboarding.dialog.welcome.title')), 1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$msg('navbar.onboarding.dialog.welcome.subtitle')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_openBlock(), _createElementBlock("div", {
          key: `${_unref(isMobileSplashScreenDisplayed)}`,
          slot: "dialog-body",
          class: "onboarding-modal_body flex"
        }, [
          (isMobile.value)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : _createCommentVNode("", true),
          (_unref(isMobileSplashScreenDisplayed) && isMobile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$msg('navbar.onboarding.dialog.welcome.title')), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$msg('navbar.onboarding.dialog.welcome.subtitle')), 1)
                ]),
                _hoisted_8
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (isMobile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(OnboardingNewUserCard, {
                        card: _unref(selectedOnboardingCard),
                        index: _unref(selectedOnboardingCardIndex)
                      }, null, 8, ["card", "index"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(onboardingSteps), (card, index) => {
                        return (_openBlock(), _createBlock(OnboardingNewUserCard, {
                          key: index,
                          card: card,
                          index: index
                        }, null, 8, ["card", "index"]))
                      }), 128))
                    ])),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    class: "onboarding-modal_body_content_illustration_image",
                    loading: "lazy",
                    src: _unref(selectedIllustation)
                  }, null, 8, _hoisted_13)
                ])
              ]))
        ])),
        (_unref(isMobileSplashScreenDisplayed) && isMobile.value)
          ? (_openBlock(), _createBlock(_component_joy_button, {
              key: "splash",
              slot: "dialog-confirm",
              variant: "main",
              class: "onboarding-modal_body_footer",
              onClick: handleSpashScrenConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$msg('navbar.onboarding.dialog.welcome.cta.title')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (isMobile.value && !_unref(isMobileSplashScreenDisplayed))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_joy_indicators, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(onboardingSteps).length, (index) => {
                          return (_openBlock(), _createBlock(_component_joy_indicator, {
                            key: index,
                            selected: _unref(selectedOnboardingCardIndex) + 1 === index
                          }, null, 8, ["selected"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_component_joy_button, {
                key: getCtaMessage.value,
                variant: _unref(isAtLastStep) ? 'main' : 'primary',
                onClick: _unref(onBoardingNewUserStore).goToNextCard
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getCtaMessage.value), 1)
                ]),
                _: 1
              }, 8, ["variant", "onClick"]))
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})